export default "__VITE_ASSET__def935ab__"